import axios from 'axios';
export async function runAxiosAsync(url, request, args = {}) {
  try {
    request.userID = window.userID;
    const timeout = args.timeout === undefined ? 30000 : args.timeout;
    const response = await axios.post(url, request, { timeout: timeout });
    return response.data;
  } catch (error) {
    const isTimeout = error.code === 'ECONNABORTED' ||
      error.message?.includes('timeout') ||
      error.name === 'TimeoutError';

    if (isTimeout) {
      if (!args.userID || !args.jobID) {
        throw new Error('Missing userID or jobID for polling after timeout');
      }

      return {
        status: 'processing',
        user_id: args.userID,
        job_id: args.jobID,
        timeout_occurred: true
      };
    }

    const errorMessage = error.response?.data?.message || error.message || 'Unknown error';
    const errorCode = error.response?.status || error.code;

    throw new Error(`Failed to submit parse request: ${errorMessage} (Code: ${errorCode})`);
  }
}
export const runAxios = (url, request, callback,args) => {

  //add userID
  request.userID = window.userID;
  const timeout = args.timeout === undefined ? 60000 : args.timeout;
  const props = args.props;
  const stateProps = props.stateProps;
  const firstMulti = args.firstMulti === undefined ? false : args.firstMulti;
  const secondMulti = args.secondMulti === undefined ? false : args.secondMulti;
  if((typeof args.silent === 'undefined' || args.silent === false) && !secondMulti) {
  //  stateProps.setSpinnerMessage(args.message);
  }
  axios.post(url, request,{timeout: timeout })
    .then(
      (result) => {
        callback(result,args);
      },stateProps
    ).catch((error) => {
      alert('There was an issue please try again.');
    stateProps.onSpinnerClose();
    }

  ).finally(() => {
;
  })
};
